import Vue from 'vue'
import VueRouter from 'vue-router'
import GestionPortal from '../views/GestionPortal.vue'
import TestComponents from '../views/TestComponents.vue'
import Pericias from '../views/Pericias.vue'

import PasswordChanged from '../views/PasswordChanged.vue'
import PruebaLoginEmpleado from '../views/pruebaLoginEmpleado.vue'

import Subsidios from '../views/Subsidios.vue'
import Nacimiento from '../views/Nacimiento.vue'
import MadreNoGestante from '../views/MadreNoGestante.vue'
import UnionConvivencial from '../views/UnionConvivencial.vue'
import Maternidad from '../views/Maternidad.vue'
import Matrimonio from '../views/Matrimonio.vue'
import Adopcion from '../views/Adopcion.vue'

import MediosDeContacto from '../views/MediosDeContacto.vue'
import Prestamos from '../views/Prestamos.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import ListarDatosPersonales from '../views/ListarDatosPersonales.vue'
import ListadoFamiliares from '../views/ListadoFamiliares.vue'
import ListarContactos from '../views/ListarContactos.vue'
import CambiarPassword from '../views/CambiarPass.vue'
import RecuperarPassword from '../views/RecoverPassword.vue'
import Boletas from '../views/Boletas.vue'
import Comunicaciones from '../views/Comunicaciones.vue'
import Notificaciones from '../views/Notificaciones.vue'
import DetalleDeAportes from '@/views/DetalleDeAportes.vue'
import ConsultaPagos from '@/views/ConsultaPagos.vue'
import Haberes from '../views/Haberes.vue'
import Turnos from '../views/Turnos.vue'
import CheckOutMercadoPago from '../views/CheckOutMercadoPago.vue'
import OpcionDeNivel from '../views/OpcionDeNivel.vue'
import PlanesDePago from '../views/PlanesDePago.vue'
/* import MediosDePago2 from '../views/MediosDePago2.vue' */
import Tramites from '../views/Tramites.vue'
//import Supervivencia from '../views/Supervivencia.vue'
import Preafiliacion from '../views/PreAfiliacion.vue'
import FormularioAfiliacion from '../views/FormularioAfiliacion.vue'
import Recibos from '@/views/RecibosAporteHaberes.vue'
import Mantenimiento from '@/views/Mantenimiento.vue'
import store from '@/store'
import * as sessionModel from '@/services/sessionModel'

Vue.use(VueRouter)

const routes = [
  {
    // Comodin: URL sin match (typo/bookmark viejo). VERIFICADO EMPIRICAMENTE
    // (apply gestion-flow-hardening): en Vue Router 3 el `redirect` se
    // resuelve en match() ANTES de que corran los guards — el `beforeEnter`
    // de este route record (con su sessionStorage.clear() suelto) NUNCA
    // ejecuta, porque `to` ya llega resuelto al target del redirect y
    // `to.matched` no incluye este record. Se removio (dead code); la
    // proteccion real para el comodin bajo contexto de operador la da
    // `beforeEach` (regla 2: redirect-all a /gestionPortal).
    path: '*',
    redirect: '/login',
    component: Login,
  },
  {
    path: '/mantenimiento',
    name: 'mantenimiento',
    component: Mantenimiento,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/testComponents',
    name: 'testComponents',
    component: TestComponents,
  },
  {
    path: '/gestionPortal',
    name: 'gestionPortal',
    component: GestionPortal,
    // Bloquea el acceso por URL sin un codigo de gestion valido.
    // Solo verifica la presencia del query param `code` (no vacio).
    // La validacion real del codigo ocurre en el back al canjearlo.
    beforeEnter: (to, from, next) => {
      // En la entrada inicial la URL trae ?code (handoff de SICA). GestionPortal
      // lo canjea y lo remueve de la URL, por lo que en un REFRESH ya no esta;
      // pero la sesion de operador queda persistida en sessionStorage
      // (gestion_sid). Permitimos entrar si hay code (entrada inicial) O si ya
      // existe una sesion de gestion activa (refresh), para no expulsar al login.
      const tieneCode = !!to.query.code
      const sesionGestion = sessionModel.hayContextoOperador()
      if (!tieneCode && !sesionGestion) {
        return next('/login')
      }
      next()
    },
  },
  {
    path: '/listarDatosPersonales',
    name: 'listarDatosPersonales',
    component: ListarDatosPersonales,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/listarFamiliares',
    name: 'listarFamiliares',
    component: ListadoFamiliares,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('getFamiliar', sessionStorage.getItem('nroafi'), { root: true })
      next()
    }
  },
  {
    path: '/listarContactos',
    name: 'listarContactos',
    component: ListarContactos,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('auth/refreshToken', null, { root: true })
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('common/levantarCommon', null, { root: true })
      store.dispatch('getEmail', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('getDomicilio', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('getTelefono', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('auth/setSktLoader', true, { root: true })
      next()
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('auth/refreshToken', null, { root: true })
      //store.dispatch('auth/setSktLoader', true, { root: true })
      // peticiono a la API directamente en el router antes de entrar
      //store.dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('common/levantarCommon', null, { root: true })
      /*       debugger
            if (store.getters['auth/isAuthenticated']) {
              store.dispatch('auth/getUser', { nroafi: sessionStorage.getItem('nroafi'), bit: 0 }, { root: true })
            } */
      if (store.getters['opcionNivel/opcionNivelHabilitado']) {
        store.dispatch('opcionNivel/getNivelAfiliado', null, { root: true })
      }
      store.dispatch('getEmail', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('getDomicilio', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('getTelefono', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('getFamiliar', sessionStorage.getItem('nroafi'), { root: true })

      //peticiono si requiere validar datos de contacto y/o fotoCarnet es vacio

      next()
    }
  },

  //SUBSIDIOS
  // Las siete rutas quedan declaradas siempre y el corte lo hace el guard, no el
  // comentario: asi el feature se prende o apaga cambiando VUE_APP_SUBSIDIOS y no
  // descomentando codigo. El guard va en LAS SIETE, no solo en /subsidios: son URLs
  // adivinables y ocultar el item del menu no cierra la puerta. Siempre es la
  // primera sentencia del beforeEnter, antes de los dispatch, para no pedirle datos
  // a la API de una vista que no se va a mostrar.
  {
    path: '/subsidios',
    name: 'subsidios',
    component: Subsidios,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['subsidios/subsidiosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      //store.dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('subsidios/validarAportesPagos', { nroafi: sessionStorage.getItem('nroafi') }, { root: true })
      store.dispatch('subsidios/validarPlanPagos', { nroafi: sessionStorage.getItem('nroafi') }, { root: true })
      next()
    }
  },
  {
    path: '/adopcion',
    name: 'adopcion',
    component: Adopcion,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['subsidios/subsidiosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('common/levantarCommon', null, { root: true })
      store.dispatch('subsidios/obtenerFamiliaresSubsidio', { nroafi: sessionStorage.getItem('nroafi'), tipoSubsidio: '1' }, { root: true })
      store.dispatch('subsidios/getMediosPaagos', null, { root: true })
      next()
    }
  },
  {
    path: '/nacimiento',
    name: 'nacimiento',
    component: Nacimiento,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['subsidios/subsidiosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('mediosDePago/getBancos', null, { root: true })
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('common/levantarCommon', null, { root: true })
      store.dispatch('subsidios/obtenerFamiliaresSubsidio', { nroafi: sessionStorage.getItem('nroafi'), tipoSubsidio: '1' }, { root: true })
      store.dispatch('subsidios/getMediosPaagos', null, { root: true })
      next()
    }
  },
  {
    path: '/maternidad',
    name: 'maternidad',
    component: Maternidad,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['subsidios/subsidiosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('common/levantarCommon', null, { root: true })
      store.dispatch('subsidios/obtenerFamiliaresSubsidio', { nroafi: sessionStorage.getItem('nroafi'), tipoSubsidio: '1' }, { root: true })
      store.dispatch('subsidios/getMediosPaagos', null, { root: true })
      next()
    }
  },
  {
    path: '/madre_no_gestante',
    name: 'madre_no_gestante',
    component: MadreNoGestante,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['subsidios/subsidiosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('common/levantarCommon', null, { root: true })
      store.dispatch('subsidios/obtenerFamiliaresSubsidio', { nroafi: sessionStorage.getItem('nroafi'), tipoSubsidio: '1' }, { root: true })
      store.dispatch('subsidios/getMediosPaagos', null, { root: true })
      next()
    }
  },
  {
    path: '/matrimonio',
    name: 'matrimonio',
    component: Matrimonio,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['subsidios/subsidiosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('mediosDePago/getBancos', null, { root: true })
      store.dispatch('common/levantarCommon', null, { root: true })
      store.dispatch('subsidios/obtenerFamiliaresSubsidio', { nroafi: sessionStorage.getItem('nroafi'), tipoSubsidio: '2' }, { root: true })
      store.dispatch('subsidios/getMediosPaagos', null, { root: true })
      next()
    }
  },
  {
    path: '/union-convivencial',
    name: 'union-convivencial',
    component: UnionConvivencial,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['subsidios/subsidiosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('common/levantarCommon', null, { root: true })
      store.dispatch('subsidios/obtenerFamiliaresSubsidio', { nroafi: sessionStorage.getItem('nroafi'), tipoSubsidio: '2' }, { root: true })
      store.dispatch('subsidios/getMediosPaagos', null, { root: true })
      next()
    }
  },
  {
    path: '/recuperarPassword',
    name: 'recuperarPassword',
    component: RecuperarPassword,
    beforeEnter: (to, from, next) => {
      store.dispatch('reestablecerErrorRecover', null)
      next()
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/pericias',
    name: 'Pericias',
    component: Pericias,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('auth/refreshToken', null, { root: true })
      // peticiono a la API directamente en el router antes de entrar
      //store.dispatch('auth/setSktLoader', true, { root: true })
      //store.dispatch('pericias/getPericias', null, { root: true })
      next()
    }
  },
  {
    path: '/detalleDeAportes',
    name: 'DetalleDeAportes',
    component: DetalleDeAportes,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('boletas/consultarOrdenActiva', null, { root: true })
      //store.dispatch('boletas/getBoletasDisponibles', null, { root: true })
      store.dispatch('boletas/getDetalleAfiliado', null, { root: true })
      next()
    }
  },
  {
    path: '/consultaPagos',
    name: 'ConsultaPagos',
    component: ConsultaPagos,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('boletas/getConsultarPagos', null, { root: true })
      next()
    }
  },

  // REVISAR, para mas adelante
  // y por las dudas accedo a las opciones de nivel externamente
  /*   {
      path: '/OpcionNivelSica',
      name: 'OpcionDeNivelSica',
      component: OpcionDeNivelSica,
    }, */
  {
    path: '/formularioAfiliacion',
    name: 'formularioAfiliacion',
    component: FormularioAfiliacion,
    afterEach: (to, from) => {
      //Ejecuta después de cambiar de ruta
    },
    beforeEnter: (to, from, next) => {
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('common/levantarCommon', "filtro", { root: true })
      store.dispatch('common/getItemsNivel', null, { root: true })
      next()
    }
  },
  {
    path: '/mediosDeContacto',
    name: 'MediosDeContacto',
    component: MediosDeContacto,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('common/getDatosDistrito', { datoComun: "obtenerDatosDistrito", idDistrito: sessionStorage.getItem('distrito') }, { root: true })
      //  this.getters['dataUser/preArchFamiliares']
      //this.getDatosDistrito({ 'idDistrito': this.user.distrito })
      /* store.dispatch('common/getDatosDistrito', {}, { root: true }) */
      //store.dispatch('notificaciones/startLoading', null, { root: true })
      next()
    }
  },
  {
    path: '/checkOutMercadoPago',
    name: 'checkOutMercadoPago',
    component: CheckOutMercadoPago,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {

      //consulto orden activa
      store.dispatch('boletas/consultarOrdenActiva', null, { root: true })

      store.dispatch('auth/setSktLoader', true, { root: true });
      next();
    }
  },
  {
    path: '/cambiarPassword',
    name: 'CambiarPassword',
    component: CambiarPassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/passwordChanged',
    name: 'PasswordChanged',
    component: PasswordChanged,
  },
  {
    path: '/tramites',
    name: 'tramites',
    component: Tramites,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // peticiono a la API directamente en el router antes de entrar
      //store.dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('tramites/getTramites', null, { root: true })
      next()
    }
  },
  {
    path: '/prestamos',
    name: 'Prestamos',
    component: Prestamos,
    meta: {
      requiresAuth: true
    },
  },

  {
    path: '/opcionDeNivel',
    name: 'opcionDeNivel',
    component: OpcionDeNivel,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['opcionNivel/opcionNivelHabilitado']) {
        return next('/dashboard')
      }
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('opcionNivel/getNivelAfiliado', null, { root: true })
      store.dispatch('getEmail', sessionStorage.getItem('nroafi'), { root: true })
      next()
    },
  },
  {
    path: '/recibos',
    name: 'recibos',
    component: Recibos,
    meta: {
      requiresAuth: true
    }
  },
  /*   {
      path: '/supervivencia',
      name: 'supervivencia',
      component: Supervivencia,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        // peticiono a la API directamente en el router antes de entrar
        //store.dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
        store.dispatch('auth/refreshToken', null, { root: true })
        store.dispatch('auth/setSktLoader', true, { root: true })
        store.dispatch('opcionNivel/getNivelAfiliado', null, { root: true })
        next()
      },
    },
    */

  /*   {
      path: '/mediosDePago2',
      name: 'mediosDePago2',
      component: MediosDePago2,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        // peticiono a la API directamente en el router antes de entrar
        store.dispatch('auth/setSktLoader', true, { root: true })
        //store.dispatch('mediosDePago/obtenerParametrosPlanPago', null, { root: true })
        //store.dispatch('mediosDePago/obtenerDeudaPlanPago', null, { root: true })
        store.dispatch('mediosDePago/obtenerMediosPago', null, { root: true })
        store.dispatch('mediosDePago/aportesActivos', null, { root: true })
        next()
      }
    }, */
  {
    path: '/planesDePago',
    name: 'planesDePago',
    component: PlanesDePago,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {

      // manejo de componente Skeleton loader
      store.dispatch('auth/setSktLoader', true, { root: true })

      // El reset DEBE quedar aca y antes del dispatch: si lo hace el created() de
      // la vista compite con la respuesta HTTP y, cuando la API responde rapido,
      // pisa el mensaje recien commiteado y la pantalla queda vacia.
      store.dispatch('mediosDePago/resetModulo', null, { root: true })

      // evalua deuda de plan de pago
      store.dispatch('mediosDePago/obtenerDeudaPlanPago', null, { root: true })
      next()
    }
  },
  {
    path: '/comunicaciones',
    name: 'Comunicaciones',
    component: Comunicaciones,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('comunicaciones/obtenerComunicaciones', { nroafi: sessionStorage.getItem('nroafi') }, { root: true })
      next()
    }
  },
  {
    path: '/notificaciones',
    name: 'Notificaciones',
    component: Notificaciones,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // Ocultar el boton no cierra la puerta: sin este guard cualquiera entra
      // escribiendo /notificaciones en la barra de direcciones.
      if (!store.getters['avisos/avisosHabilitados']) {
        return next('/dashboard')
      }
      // peticiono a la API directamente en el router antes de entrar
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('avisos/obtenerAvisos', null, { root: true })
      next()
    }
  },

  {
    path: '/haberes',
    name: 'haberes',
    component: Haberes,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // peticiono a la API directamente en el router antes de entrar
      //store.dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('auth/refreshToken', null, { root: true })
      next()
    }
  },
  {
    path: '/boletas',
    name: 'boletas',
    component: Boletas,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('auth/setSktLoader', true, { root: true })
      //consulto orden activa
      store.dispatch('getEmail')
      store.dispatch('boletas/getCargaConceptos', null, { root: true })
      store.dispatch('boletas/consultarOrdenActiva', null, { root: true })
      // peticiono a la API directamente en el router antes de entrar
      //store.dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
      next()
    },
  },
  {
    path: '/turnos',
    name: 'turnos',
    component: Turnos,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // peticiono a la API directamente en el router antes de entrar
      //store.dispatch('auth/getUser', sessionStorage.getItem('nroafi'), { root: true })
      store.dispatch('auth/setSktLoader', true, { root: true })
      store.dispatch('auth/refreshToken', null, { root: true })
      store.dispatch('turnos/getTurnosActivos', { nroafi: sessionStorage.getItem('nroafi') }, { root: true })
      next()
    }
  },

  {
    path: '/preafiliacion',
    name: 'preafiliacion',
    component: Preafiliacion,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/pruebaLoginEmpleado',
    name: 'PruebaLoginEmpleado',
    component: PruebaLoginEmpleado,
    meta: {
      requiresAuth: false
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//store.dispatch('auth/setSktLoader', true, { root: true })
router.beforeEach(async (to, from, next) => {
  const token = sessionStorage.getItem('token');

  // Regla 1: navegacion DENTRO del iframe de gestion (same-origin). El
  // operador navega libre entre rutas protegidas del afiliado; cualquier
  // otro destino (login, publicas, token vencido) se resuelve avisando al
  // padre por postMessage y abortando esta navegacion in-frame.
  // Se exige hayContextoOperador() ademas de esFrame(): la app tambien se
  // auto-enmarca fuera de gestion (iframe de MercadoPago que vuelve a
  // /checkOutMercadoPago), y ese frame NO tiene gestion_sid, por lo que
  // debe seguir el ruteo normal (regla 3) en vez de esta regla in-frame.
  if (sessionModel.esFrame() && sessionModel.hayContextoOperador()) {
    const requiresAuthAqui = to.matched.some(record => record.meta.requiresAuth === true);
    if (token && requiresAuthAqui) {
      return next();
    }
    // token presente pero ruta no requiresAuth (ej. /login publica dentro
    // del frame), o token ausente/expirado: avisar al padre y abortar.
    // next(false) EXPLICITO: omitir next() deja el guard colgado.
    window.parent.postMessage({ type: 'gestion-cerrar-sesion' }, window.location.origin);
    return next(false);
  }

  // Regla 2: contexto de operador TOP-LEVEL (fuera del iframe). Unico
  // destino top-level permitido = /gestionPortal (+ /mantenimiento).
  // Cierra por construccion todos los caminos residuales a rutas de
  // afiliado (incl. /dashboard) o al login de afiliados bajo gestion.
  if (sessionModel.hayContextoOperador()) {
    const ALLOWLIST_OPERADOR = ['/gestionPortal', '/mantenimiento'];
    if (ALLOWLIST_OPERADOR.includes(to.path)) {
      return next();
    }
    return next('/gestionPortal');
  }

  // Regla 3: sin contexto de operador y sin frame -> comportamiento normal
  // (afiliado autenticado fuera de gestion).
  let currentUser = token;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // Verifica si la ruta requiere autenticación
  if (!currentUser && requiresAuth) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    if (currentUser && !requiresAuth) {
      // Redirige al cerrar sesión si intenta ir a la página de login o recuperar contraseña mientras está autenticado
      const rutasNoPermitidas = ['/login', '/RecuperarPassword', '/preafiliacion', '/cambiarPassword', '/formularioAfiliacion'];
      if (rutasNoPermitidas.includes(to.path)) {
        next({
          path: '/dashboard',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    } else {
      // Verifica si la ruta requiere que el afiliado esté activo
      const requiereActivo = to.matched.some(record => record.meta.requiereActivo);
      if (requiereActivo) {
        // Obtener `esactivo` desde Vuex
        const esActivo = store.state.afiliado.esactivo;

        // Verifica el estado `esactivo` antes de proceder
        if (esActivo === 0) {
          // Redirige a una página de acceso denegado si no está activo
          return next({ path: '/acceso-denegado' });
        }
      }
      next();
    }
  }
});


/*
router.beforeEach(async (to, from, next) => {
 
  let loginRequired = to.matched.some(record => record.meta.requiresAuth);
  let currentUser = store.getters['auth/isAuthenticated'];
  console.log("necesita auth: " + loginRequired)
  console.log("usuario: " + currentUser)
  if (loginRequired && !currentUser && to.path !== '/login') {
    next('/login');
  } else if (!loginRequired && currentUser) {
    next('/dashboard');
    // if none of the above matches, we have a normal navigation that should just go through
    // so we call `next()`
  } else {
    next(); // you called `next('/')` which redirected to the homepage over and over again.
  }
 
  //var currentUser = localStorage.getItem('nroafi');
 
 
})
 
// cuando la ruta requiere autorizacion y no hay usuario, redirecciona a /login
/* if (loginRequired && (currentUser !== null)) {
  console.log(loginRequired)
  console.log(currentUser)
  next('/login');
 
    } else if (!loginRequired && currentUser) {
      next('/dashboard');
 
  // if none of the above matches, we have a normal navigation that should just go through
  // so we call `next()`
} else {
  next(); // you called `next('/')` which redirected to the homepage over and over again.
}
 
});
/*
// cuando la ruta requiere autorizacion y no hay usuario, redirecciona a /login
if (loginRequired && !currentUser && to.path !== '/login') {
  next('/login');
} else if (!loginRequired && currentUser) {
  next('/dashboard');
  // if none of the above matches, we have a normal navigation that should just go through
  // so we call `next()`
} else {
  next(); // you called `next('/')` which redirected to the homepage over and over again.
}
 
}); */
export default router